import { Stack, Text } from '@ekhodealer/ekho-common/rev';

import { DmsConnectionForm } from './DmsConnectionForm';
import { EkhoAccessForm } from './EkhoAccessForm';
import { FieldGroupPrecedenceForm } from './FieldGroupPrecedenceForm';
import { WebsiteScrapingForm } from './WebsiteScrapingForm';

/**
 * InventoryForms composes all inventory configuration forms together:
 * 1. DmsConnectionForm - DMS provider connection configuration
 * 2. WebsiteScrapingForm - Website scraping configuration
 * 3. FieldGroupPrecedenceForm - Field group precedence/data source preferences
 * 4. EkhoAccessForm - Invite Ekho employees with CMS/DNS access
 */
export function InventoryForms() {
	return (
		<Stack itemsSpacing='32'>
			<Stack itemsSpacing='8'>
				<Text size='bodySmall' weight='semibold' color='information'>
					Step 1
				</Text>
				<DmsConnectionForm />
			</Stack>

			<Stack itemsSpacing='8'>
				<Text size='bodySmall' weight='semibold' color='information'>
					Step 2
				</Text>
				<WebsiteScrapingForm />
			</Stack>

			<Stack itemsSpacing='8'>
				<Text size='bodySmall' weight='semibold' color='information'>
					Step 3
				</Text>
				<FieldGroupPrecedenceForm />
			</Stack>

			<Stack itemsSpacing='8'>
				<Text size='bodySmall' weight='semibold' color='information'>
					Step 4
				</Text>
				<EkhoAccessForm />
			</Stack>

			<Text size='body' color='secondary' align='center'>
				Don&apos;t see your DMS and Website provider? Let us know by emailing{' '}
				<a href='mailto:support@ekho.com'>support@ekho.com</a>. We&apos;re always looking
				for more integrations!
			</Text>
		</Stack>
	);
}

export default InventoryForms;
